import * as React from "react";

const GSPDeviceInformation = ({ brand, model, serialNumber, lens, lensSerialNumber, owner }) => {
  return (
    <div className="geoseearch-photo__device">
      <h2>Device Information:</h2>
      <div className="geoseearch-photo__device-container">
        <div className="geosearch-photo__device-brand">
          <h5>Brand</h5>
          <p>{brand}</p>
        </div>
        <div className="geosearch-photo__device-model">
          <h5>Model</h5>
          <p>{model}</p>
        </div>
        <div className="geosearch-photo__device-serial-number">
          <h5>Serial Number</h5>
          <p>{serialNumber}</p>
        </div>
        <div className="geosearch-photo__device-lens">
          <h5>Lens</h5>
          <p className="hyphenate">{lens}</p>
        </div>
        <div className="geosearch-photo__device-lens-serial-number">
          <h5>Lens Serial Number</h5>
          <p className="hyphenate">{lensSerialNumber}</p>
        </div>
        <div className="geosearch-photo__device-owner">
          <h5>Owner</h5>
          <p>{owner}</p>
        </div>
      </div>
    </div>
  );
};

export default GSPDeviceInformation;



// WEBPACK FOOTER //
// ./src/modules/GeoSearch/Photo/components/GSPDeviceInformation.tsx